import { render } from "./followerView.vue?vue&type=template&id=0c0800f8"
import script from "./followerView.vue?vue&type=script&lang=js"
export * from "./followerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__